// Standard library imports
import React, { useEffect, useState } from 'react';

// External library imports
import { toast } from 'react-toastify';
import moment from 'moment';
import { useLoader } from '../../../../hooks';
import { momentTimeFormater, timeOnlyWithms } from '../../../../utils/dateHelper';
import { usToEuCurrencyFormat } from '../../../../utils/currencyHelper';

// Css imports
import SignalViewerClasses from '../../index.module.css';
import EChart from '../../../../components/Echarts/Echarts';
import Typography from '../../../../components/Typography/Typography';
import { signalsService } from '../../../../services/signalsService';

const MFRRActivationSignalViewer = ({ data, setOpen }) => {
    const curCetDateTime = moment().tz('Europe/Berlin');
    const [startLoader, stopLoader] = useLoader();
    const [powerData, setPowerData] = useState([]);
    const [setPointData, setSetPointData] = useState([]);
    const [date, setDate] = useState(new Date(curCetDateTime.format()));
    const [signal, setSignal] = useState({});
    const [lastStatus, setLastStatus] = useState('--');

    const readSignal = (params, successHandler) => {
        signalsService.ReadSignalDataFromSource(
            params,
            () => startLoader('read-data'),
            successHandler,
            handleError,
            () => stopLoader('read-data')
        );
    };

    const getLastReportedData = () => {
        if (data?.signalId) {
            signalsService.getLastReportedData({ signalId: data?.signalId }, startLoader, handleLastReportedSuccess, handleError, stopLoader);
        }
    };

    const handleLastReportedSuccess = ({ data }) => {
        if (data.data) {
            setLastStatus(moment(data?.data).tz('Europe/Berlin').format('YYYY-MM-DD HH:mm:ss'));
        } else {
            setLastStatus('--');
        }
    };

    const handleSignalDataSucess = ({ data }) => {
        setPowerData(data.data?.power);
        setSetPointData(data.data?.setPoint || []);
    };

    useEffect(() => {
        if (data?.signalId) {
            let params = {
                start: moment(data.startTime).tz('Europe/Berlin').format('HH:mm:ss'),
                end: moment(data.endTime).tz('Europe/Berlin').format('HH:mm:ss'),
                date: moment(data.startTime).tz('Europe/Berlin').format('YYYY-MM-DD'),
                signalId: data?.signalId,
                prefillData: false,
                dataDecimation: false,
            };
            readSignal(params, handleSignalDataSucess);
            getLastReportedData(signal?.value);
        }
    }, [data?.signalId]);

    const handleError = (err) => {
        if (err) {
            toast.error(err?.response?.data?.message);
        }
    };

    const formatYAxisValue = (value) => {
        return usToEuCurrencyFormat(value, 3);
    };

    return (
        <div style={{ height: '80vh', width: '80vw', overflowY: 'scroll' }}>
            <Typography content={`Signal Viewer`} />

            <div className={SignalViewerClasses.ParentWrapper}>
                <div style={{ backgroundColor: '#f4f7fc' }}>
                    <div>
                        <div>
                            <div>
                                <EChart
                                    series={setPointData || []}
                                    group={'signalLog'}
                                    title={'Set Point'}
                                    lastReported={lastStatus}
                                    xFormatter={(v) => timeOnlyWithms(momentTimeFormater(v))}
                                    yFormatter={formatYAxisValue}
                                    type="line"
                                    zoomOnMouseWheel={false}
                                    yTooltipSuffix={['%']}
                                />
                            </div>
                        </div>

                        <div style={{ marginBottom: '1.5vh' }}>
                            <div>
                                {
                                    <EChart
                                        series={powerData || []}
                                        group={'signalLog'}
                                        title={'Power'}
                                        lastReported={lastStatus}
                                        xFormatter={(v) => timeOnlyWithms(momentTimeFormater(v))}
                                        yFormatter={formatYAxisValue}
                                        type="line"
                                        zoomOnMouseWheel={false}
                                        yTooltipSuffix={['kW']}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={SignalViewerClasses.ButtonContainer}>
                <div className="btn-primary" onClick={() => setOpen({ status: false, data: '' })} style={{ minWidth: 'auto' }}>
                    Close
                </div>
            </div>
        </div>
    );
};

export default MFRRActivationSignalViewer;
